import script from "./AddNeetForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNeetForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__